module.exports = function (app) {

    app.controller('pages.account.view-id-card', ['$scope','UMSParse','coremetrics','sessionData', 'brand','services', 'storage', '$http','modal', 'aemContent','$timeout',
        function ($scope, UMSParse,coremetrics, sessionData, brand, services, storage, $http, modal, aemContent,$timeout) {
            window.$scope = $scope;
            var orderCardCoremetrics = false;
            var allowSend = false;
            $scope.sessionData = sessionData;
            $scope.sidebar.links = [];
            $scope.sidebar.links.push({
                heading: "ID CARD OPTIONS",
                hide:true,
                disabled: true,
                active: false,
                description: "View, fax, and order ID card(s)&#8722; wherever you are.",
                state: "viewIdCard"
            });
            $scope.backAction = function(){window.history.back();};
            $scope.fullPageError = false;
            $scope.orderingBlocked = false;
            $scope.usePermAddress = true;
           // $scope.selectedMember = {
           //     value: 0
           // };
            aemContent.get('MER_IDCARD_REPORT_STOLEN').then(function(response){
                $scope.MER_IDCARD_REPORT_STOLEN= response;
                return $scope.MER_IDCARD_REPORT_STOLEN;
            });
            $scope.idCardScroll = {
                swipe:true ,
                snap: true,
                goToCallback: function(pos, oldPos) {
                   // $scope.selectedUser.cards[oldPos].selected = "not-selected";
                    $scope.selectedUser.cards[pos].selected = "selected";
                    if (pos != oldPos) {
                        // switched cards, make sure it's flipped front-side up
                        $scope.selectedUser.cards[pos].viewBack = false;
                        $scope.viewBack = false;

                        //if (this.cardSwitchCoremetrics != true && changeMember4Core!=true) {
                        //    this.cardSwitchCoremetrics = true;
                        //    btsGlobal.coremetrics.elementTag('View another card','MEMBER:ACCOUNT SETTINGS');
                        //}
                    }
                    $scope.selectedCard = angular.copy($scope.selectedUser.cards[pos]);

                    if ($scope.selectedUser.cards[pos].error) {
                        $scope.currentcardHasError = true;
                    }
                    else {
                        $scope.currentcardHasError = false;
                    }

                }
            };
            var memberData = sessionData.memberInfo;
            var serverDate = new Date();
            var ums = new UMSParse(memberData, serverDate);
            var baseInfo = ums.baseInformation();
            var parsedresponse;
            parsedresponse = ums.ASMemberInfoFeed();
            //-----------------------------------FUNCTIONS---------------------------------------------------
             var errors = function(type) {
                //    /*
                //     "cancelled": "This coverage is no longer active. You cannot view this card.",
                //     "ecsDown": "This card cannot be displayed. For more information, please contact customer service. ",
                //     "IBCDown": "You are temporarily unable to view or print your member ID card. Please check back soon or call Customer Service at 1-800-ASK-BLUE for assistance. We apologize for the inconvenience.",
                //     "IBCAHDown": "You are temporarily unable to view or print your member ID card. Please check back soon or call Customer Service at 1-888-968-7241 for assistance. We apologize for the inconvenience."
                 switch (type) {
                     case "cancelled":
                         return "This coverage is no longer active. You cannot view this card.";
                         break;
                     case "ecsDown":
                         return "This card cannot be displayed. For more information, please contact customer service. ";
                         break;
                     case "IBCDown":
                         return "You are temporarily unable to view or print your member ID card. Please check back soon or call Customer Service at 1-800-ASK-BLUE for assistance. We apologize for the inconvenience.";
                         break;
                     case "IBCAHDown":
                         return "You are temporarily unable to view or print your member ID card. Please check back soon or call Customer Service at 1-888-968-7241 for assistance. We apologize for the inconvenience." ;
                        break;
                 }
             };
            function benefitTypeToCType(benefitPlanType) {
                benefitPlanType = benefitPlanType.toLowerCase();
                switch (benefitPlanType) {
                    case "medical":
                        return "MED";
                    case "dental":
                        return "DEN";
                    case "drug":
                        return "PDG";
                    case "vision":
                        return "VIS";
                }
            }
            function cardTypeToDisplay(cardType) {
                switch (cardType) {
                    case "Drug":
                        return "Prescription Drug";
                    default:
                        return cardType;
                }
            }
            function cardTypeToIcon(cardType) {
                switch (cardType) {
                    case "Medical":
                        return "icon-provider";
                    case "Dental":
                        return "icon-dental";
                    case "Drug":
                        return "icon-pharmacy";
                    case "Vision":
                        return "icon-vision";
                }
            }
            $scope.selectedMemberChange= function() {
                $scope.errorMessage = false;
                var tempSelectedUser = angular.copy($scope.users[$scope.selectedMember.value]);
                $scope.selectedUser = tempSelectedUser;
                $scope.multipleCards = false;
                $scope.viewBack = false;
                if ($scope.selectedUser) {
                    if ($scope.selectedUser.cards.length > 1) {
                        $scope.multipleCards = true;
                    }
                    $scope.idCardScroll.count = $scope.selectedUser.cards.length;
                    //changeMember4Core = true;
                    if ($scope.idCardScroll.goToCallback) {
                        $scope.idCardScroll.goToCallback(0);
                    }
                    //changeMember4Core = false;
                    //this.selectMemberCoremetrics(tempSelectedUser);
                }
            };
            $scope.viewBackClick = function() {

                //$scope.selectedUser.cards[$scope.idCardScroll.pos].viewBack = !$scope.selectedUser.cards[$scope.idCardScroll.pos].viewBack;
                $scope.viewBack = !$scope.viewBack;
                //if(that.viewBackCoremetrics != true)
                //{
               coremetrics.elementTag('View back of ID card','MEMBER:ACCOUNT SETTINGS');
                //    that.viewBackCoremetrics = true;
                //}
            };
            $scope.cardError= function(card) {
                card.error = true;
            };

            $scope.faxIdCard =function(){
                if($scope.showFax){
                    $scope.showFax = false;
                }
                else{
                    $scope.showFax = true;
                }
            };
            $scope.sendFaxClick = function(formName) {
                console.log(formName);

                if (formName && formName.$valid){

                    var postData = {
                        'systemIdentifier': 'WEB',
                        'logoIdDomain': $scope.baseInfo.brand,
                        'memberProfileId': '',
                        'userId': sessionData.basicInfo.loginId,
                        'eciId': $scope.selectedUser.ecId,
                        'userEmailAddress': $scope.email,
                        'cardType': $scope.selectedCard.CType,
                        'groupNumber': $scope.selectedCard.GNumber,
                        'coveredIndId': $scope.selectedUser.ciid,
                        'umiNumber': $scope.baseInfo.umi,
                        'faxNumber':formName.fax.$modelValue //.match(/[0-9]/g).join('')
                    };
                    var sendFax = services.rbsmbl.faxIdCard().sendFax(postData);

                    sendFax.then(function(postData) {
                        modal.open({
                                     template: '<h1> Fax is on its way </h1>' +
                                     ' <p>You will receive an email once the fax is delivered.</p>' +
                                     '<p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>',
                                     classes: 'sizeOfModal'
                                   })}, function(errorData) {
                        modal.open({
                                       template:'<h1> Error </h1>'+
                                        '<p>We are having trouble processing your request right now. Try again in a few minutes. If the problem continues, please call the number on the back of your member ID card.</p>' +
                                       '<p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>',
                                       classes: 'sizeOfModal'
                        })
                    });

                    if(this.faxCoremetrics != true)
                    {
                    coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:VIEW ID CARD:FAX IS ON ITS WAY',
                                                          'MEMBER:ACCOUNT SETTINGS');
                    coremetrics.elementTag('Submit fax','MEMBER:ACCOUNT SETTINGS');
                       this.faxCoremetrics = true;
                    }
                    return sendFax;
                }
            };
            $scope.printCard = function() {
                $http.get($scope.selectedCard.src).then(function(success){
                    $scope.success = success;

                    if($scope.success.data && $scope.success.data.baseMessage && $scope.success.data.baseMessage.returnCode == 200){
                        var pw = window.open($scope.selectedCard.src);
                        setTimeout(function() {
                            pw.print();
                            setTimeout(function() {
                                pw.close();
                            }, 1000);
                        }, 1000);

                    }
                    else{
                        $scope.showError = true ;
                        window.scrollTo(0,0);
                    }

                },function(error){
                    $scope.showError = true ;
                    window.scrollTo(0,0);
                });
            };
            $scope.setEmail =function(){
                if($scope.showEmail){
                    $scope.showEmail = false;
                }
                else{
                    $scope.showEmail = true;
                }
            };
            $scope.viewEmailTerms = function() {
                modal.open({
                    heading: 'EMAIL TERMS AND CONDITIONS',
                    template: '<p style="padding-top:5px">You are about to send protected health information via email.</p>' +
                    '<p style="padding-top:15px">We do not assume any responsibility for any harm, loss or damage you may experience or incur by sending personal or confidential information via email.</p>' +
                    '<p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>',
                    classes : 'disclaimerModal'

                })
            };
            $scope.emailFrom = aemContent.get('MER_IDCARD_EMAIL_FROM').then(function(response){
                $scope.MER_IDCARD_EMAIL_FROM = response;
                return $scope.MER_IDCARD_EMAIL_FROM;
            });
            $scope.emailReplyTo = aemContent.get('MER_IDCARD_EMAIL_REPLYTO').then(function(response){
                $scope.MER_IDCARD_EMAIL_REPLYTO = response;
                return $scope.MER_IDCARD_EMAIL_REPLYTO;
            });
            $scope.emailBody = aemContent.get('MER_IDCARD_EMAIL_BODY').then(function(response){
                $scope.MER_IDCARD_EMAIL_BODY = response;
                return $scope.MER_IDCARD_EMAIL_BODY;
            });
            $scope.emailIdCard = {
                emailToAddress :'',
                emailTermsChecked : false
            };
            $scope.sendEmailClick = function(formName) {
                //var that = this;
                //this.emailInputsDisabled = true;
                console.log("email form", formName);

                if ($scope.emailIdCard.emailTermsChecked == true) {
                    if (formName.$valid) {
                        // Validation passed, call email id card service.
                        var umiAgreementIdSuffix;
                        for (var j = 0; j < $scope.selectedUser.groups.length; j++) {
                            if ($scope.selectedUser.groups[j].clientId === $scope.selectedCard.clientId && $scope.selectedUser.groups[j].groupNumber === $scope.selectedCard.groupNumber) {
                                umiAgreementIdSuffix = $scope.selectedUser.groups[j].umiAgreementIdSuffix;
                            }
                        }

                        var postData = {
                            'systemIdentifier': 'WEB',
                            'logoIdDomain': $scope.baseInfo.brand,
                            'memberProfileId': '',
                            'userId': sessionData.basicInfo.loginId,
                            'eciId': $scope.selectedUser.ecId,
                            'cardType': $scope.selectedCard.CType,
                            'groupNumber': $scope.selectedCard.GNumber,
                            'clientId': $scope.selectedCard.clientId,
                            'coveredIndId': $scope.selectedUser.ciid,
                            'umiNumber': $scope.baseInfo.umi + (umiAgreementIdSuffix ? umiAgreementIdSuffix : ''),
                            'idCardEmail': {
                                'toAddress': formName.emailToAddress.$modelValue,
                                'fromAddress': $scope.emailFrom,
                                'replyAddress': $scope.emailReplyTo,
                                'subject': 'Your Member ID Card',
                                'message': $scope.emailBody
                            },
                            'acceptTerms': $scope.emailIdCard.emailTermsChecked
                        };
                        var sendEmail = services.rbsmbl.emailIdCard().sendEmail(postData);

                        sendEmail.then(function(postData) {
                            modal.open({
                                heading: 'Email is on its way',
                                template: '<p>Member ID card email has been sent.</p>' +
                                '<p style="padding-top:12px" class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'
                            });

                            //this.emailInputsDisabled = false;


                        }, function(postData) {
                            modal.open ({
                                heading: 'Error',
                                template: '<p>We are having trouble processing your request right now. ' +
                                'Try again in a few minutes. If the problem continues, please call the number on the back of your member ID card.</p>' +
                                '<p style="padding-top:12px" class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'

                        });
                            //this.emailInputsDisabled = false;

                        });

                        //if (that.emailIdCoremetrics != true) {
                        //    btsGlobal.coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:VIEW ID CARD:EMAIL IS ON ITS WAY',
                        //                                      'MEMBER:ACCOUNT SETTINGS');
                        //    btsGlobal.coremetrics.elementTag('Submit ID Card Email','MEMBER:ACCOUNT SETTINGS');
                        //    that.emailIdCoremetrics = true;
                        //}
                    } else {
                       // this.emailInputsDisabled = false;
                    }
                } else {
                    modal.open({
                        heading: 'EMAIL TERMS AND CONDITIONS',
                        template: '<p style="font-size:15px; padding:10px">You cannot send this email until you have read and you accept the terms and conditions. ' +
                        'Please check the box to let us know you have.</p>' +
                        '<p style="padding-top:12px" class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'

                    });
                    //this.emailInputsDisabled = false;
                }
            };
            $scope.reportCard = function() {
                $scope.phone = aemContent.get('MER_IDCARD_PHONE').then(function(response){
                    $scope.MER_IDCARD_PHONE = response;
                    return $scope.MER_IDCARD_PHONE;
                });

                //var phone = '1-800-294-9568';
                $scope.phone = $scope.MER_IDCARD_PHONE;
                $scope.hours = '8:00 a.m. - 6:00 p.m., Monday - Friday,';

                switch (brand.current.sharedBrandCode.toLowerCase()) {
                    case 'ibccr':
                        $scope.phone = $scope.getIBCPhoneNumber();
                        $scope.hours = '';
                        break;
                    case 'ibcah':
                        $scope.phone = $scope.getAHPhoneNumber();
                        $scope.hours = '';
                        break;
                    default :
                        $scope.phone = $scope.MER_IDCARD_PHONE;
                        $scope.hours = '8:00 a.m. - 6:00 p.m., Monday - Friday,';
                        break;
                }
                if(this.stolenCoremetrics!=true)
                {
                    coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:VIEW ID CARD:REPORT STOLEN ID CARD', 'MEMBER:ACCOUNT SETTINGS');
                    this.stolenCoremetrics = true;
                }
                modal.open({

                    heading: 'REPORT STOLEN CARD',
                    template:'<p style="font-size:15px; padding:10px">{{MER_IDCARD_REPORT_STOLEN}}</p>' +
                    '<p style="padding-top:12px" class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'

                });
            };
            $scope.getIBCPhoneNumber = function(){

                if($scope.medicare ==='true'	&&  $scope.isHMO ==='true'){
                    var phone_HMO = aemContent.get('MER_IDCARD_PHONE_IBC_MEDICARE_HMO').then(function(response){
                        $scope.MER_IDCARD_PHONE_IBC_MEDICARE_HMO = response;
                        return $scope.MER_IDCARD_PHONE_IBC_MEDICARE_HMO;
                    });
                    return phone_HMO;
                }
                    //return this.$rootModel.teamsiteContent.MER_IDCARD_PHONE_IBC_MEDICARE_HMO;
                //return '1-800-645-3965';
                else if($scope.medicare==='true'	&& $scope.isPPO ==='true'){
                    var phone_PPO = aemContent.get('MER_IDCARD_PHONE_IBC_MEDICARE_PPO').then(function(response){
                        $scope.MER_IDCARD_PHONE_IBC_MEDICARE_PPO = response;
                        return $scope.MER_IDCARD_PHONE_IBC_MEDICARE_PPO;
                    });

                    return phone_PPO;
                }
                    //return this.$rootModel.teamsiteContent.MER_IDCARD_PHONE_IBC_MEDICARE_PPO;
                //return '1-888-718-3333';
                else if($scope.blueExtraBasic ==='true'	||	$scope.blueExtraPlus ==='true'){
                   var phone_medX = aemContent.get('MER_IDCARD_PHONE_IBC_MEDICARE_EXTRA').then(function(response){
                        $scope.MER_IDCARD_PHONE_IBC_MEDICARE_EXTRA = response;
                        return $scope.MER_IDCARD_PHONE_IBC_MEDICARE_EXTRA;
                    });
                    return phone_medX;
                }
                    //return this.$rootModel.teamsiteContent.MER_IDCARD_PHONE_IBC_MEDICARE_EXTRA;
                //return '1-800-275-2583';
                else{
                    var phone_IBC = aemContent.get('MER_IDCARD_PHONE_IBC').then(function(response){
                        $scope.MER_IDCARD_PHONE_IBC = response;
                        return $scope.MER_IDCARD_PHONE_IBC;
                    });
                    return phone_IBC;
                    //return '1-800-ASK-BLUE';
                }


            };
            $scope.getAHPhoneNumber = function(){

                var ahpa = aemContent.get('MER_IDCARD_PHONE_AH_AHPA').then(function(response){
                    $scope.MER_IDCARD_PHONE_AH_AHPA = response;
                    return $scope.MER_IDCARD_PHONE_AH_AHPA;
                });

                if($scope.ahPartner==='AHPA'){

                    return ahpa; //return '1-888-968-7421';
                }

                if($scope.ahPartner==='AHNJ'	&&	$scope.medigap==='true') {
                    var ahnj = aemContent.get('MER_IDCARD_PHONE_AH_AHNJ_MEDIGAP').then(function (response) {
                        $scope.MER_IDCARD_PHONE_AH_AHNJ_MEDIGAP = response;
                        return $scope.MER_IDCARD_PHONE_AH_AHNJ_MEDIGAP;
                    });
                    return ahnj;
                }
                else if($scope.ahPartner==='AHNJ'	&& $scope.medicare==='true') {
                    var ahnj_medicare = aemContent.get('MER_IDCARD_PHONE_AH_AHNJ_MEDICARE').then(function(response){
                        $scope.MER_IDCARD_PHONE_AH_AHNJ_MEDICARE = response;
                        return $scope.MER_IDCARD_PHONE_AH_AHNJ_MEDICARE;
                    });
                    return ahnj_medicare;
                 } else
                    return ahpa;//return '1-888-968-7421';

            };

            $scope.orderIdForm = function(){
                if($scope.orderForm){
                    $scope.orderForm = false;
                }
                else{
                    $scope.orderForm = true;
                }
            };
            $scope.idDrawer = function(member){
                if(member.open){
                    member.open = false;
                }
                else{
                    member.open = true;
                }
            };
            $scope.switchAddress = function() {
                // show/hide form fields for a user to
                // input a temp address for receiving a duplicate id card
                var that = this;
                $scope.usePermAddress = !$scope.usePermAddress;
                if ($scope.usePermAddress) {
                    $scope.address = angular.copy($scope.backupAddress);
                    if(that.removeTmpAddressCM != true)
                    {
                       coremetrics.elementTag('Remove temporary mailing address','MEMBER:ACCOUNT SETTINGS');
                        that.removeTmpAddressCM = true;
                    }
                }
                else
                {
                    if(that.useTmpAddressCM != true)
                    {
                        coremetrics.elementTag('Use a temporary mailing address','MEMBER:ACCOUNT SETTINGS');
                        that.useTmpAddressCM = true;
                    }
                }
            };
            var resetForm = function(model) {
                for (var i = 0; i < model.length; i++) {
                    var currentMember = model[i];
                    currentMember.open = false;
                    for (var z = 0; z < currentMember.cards.length; z++) {
                        var currentCard = currentMember.cards[z];
                        currentCard.checked = {value: false};
                    }
                }
            };

            $scope.cancelOrder = function() {
                if (!$scope.usePermAddress) {
                    $scope.switchAddress();
                }
                $scope.orderForm = false;
                if ($scope.hasCards) {
                    if (!$scope.hasNonAGCards) {
                        // User has cards, but only AG cards, show the form
                        $scope.orderForm = true;
                    }
                }
                resetForm($scope.users);
                var elm = document.getElementById("orderCardSection");
                elm.scrollIntoView();
            };
            $scope.submitOrder = function(formName) {

                if (!$scope.usePermAddress) {
                    var isValid = formName.$valid;
                    if (!isValid) {
                        return;
                    }
                }
                $scope.orderButtonsDisabled = true;
                //this.$apply();
                var cardRequests = {};
                var basePayload = {
                    "memberEcid": $scope.memberLoggedIn.ecId,
                    "address1": $scope.address.address1.value,
                    "address2": $scope.address.address2.value,
                    "address3": $scope.address.address3.value,
                    "address4": $scope.address.address4.value,
                    "city": $scope.address.city.value,
                    "state": $scope.address.state.value,
                    "zip": $scope.address.zip.value,
                    "zipPlus4": ""
                };
                var mtmCardRequests = [],
                    allowSend = false;
                for (var i = 0; i < $scope.users.length; i++) {
                    var currentMember = $scope.users[i];
                    for (var z = 0; z < currentMember.cards.length; z++) {
                        var currentCard = currentMember.cards[z];
                        if (currentCard.checked) {
                            cardRequests[currentCard.clientId] = cardRequests[currentCard.clientId] || {};
                            cardRequests[currentCard.clientId][currentCard.groupNumber] = cardRequests[currentCard.clientId][currentCard.groupNumber] || {};
                            cardRequests[currentCard.clientId][currentCard.groupNumber][currentCard.productNumber] = cardRequests[currentCard.clientId][currentCard.groupNumber][currentCard.productNumber] || {};
                            cardRequests[currentCard.clientId][currentCard.groupNumber][currentCard.productNumber][currentMember.ecId] = cardRequests[currentCard.clientId][currentCard.groupNumber][currentCard.productNumber][currentMember.ecId] || {
                                    "ecid": currentMember.ecId,
                                    "isIndividualSelected": "true",
                                    "isMedicalIdSelected": "",
                                    "isDentalIdSelected": "",
                                    "isVisionIdSelected": "",
                                    "isDrugIdSelected": "",
                                    "isServiceProductIdSelected": ""
                                };
                            switch (currentCard.cardType) {
                                case "Vision":
                                    cardRequests[currentCard.clientId][currentCard.groupNumber][currentCard.productNumber][currentMember.ecId].isVisionIdSelected = 'true';
                                    break;
                                case "Dental":
                                    cardRequests[currentCard.clientId][currentCard.groupNumber][currentCard.productNumber][currentMember.ecId].isDentalIdSelected = 'true';
                                    break;
                                case "Medical":
                                    cardRequests[currentCard.clientId][currentCard.groupNumber][currentCard.productNumber][currentMember.ecId].isMedicalIdSelected = 'true';
                                    //capture requested medical card for MTM reporting
                                    mtmCardRequests.push(currentCard);
                                    allowSend = true;
                                    break;
                                case "Drug":
                                case "Prescription Drug":
                                    cardRequests[currentCard.clientId][currentCard.groupNumber][currentCard.productNumber][currentMember.ecId].isDrugIdSelected = 'true';
                                    break;
                            }
                        }
                    }
                }
                var mtmData = angular.extend({}, basePayload,  {"mtmCardRequestsList": mtmCardRequests || []});

                if (allowSend){
                    //call mtm save service to persist member info - mandate
                    services.rbsmbl.capabilityInfo().persistMTMInfo(mtmData, 'orderIdCardView');
                }

                var orderServiceCalls = [];
                for (var clientId in cardRequests) {
                    for (var groupNumber in cardRequests[clientId]) {
                        for (var productNumber in cardRequests[clientId][groupNumber]) {
                            var payload = angular.copy(basePayload);
                            payload.clientId = clientId;
                            payload.groupNumber = groupNumber;
                            payload.productNumber = productNumber;
                            payload.memberList = [];
                            for (var ecId in cardRequests[clientId][groupNumber][productNumber]) {
                                payload.memberList.push(cardRequests[clientId][groupNumber][productNumber][ecId]);
                            }
                            orderServiceCalls.push(services.rbsmbl.orderIdCard().orderCards(payload))
                        }
                    }
                }
                if (orderServiceCalls.length > 0) {
                    if(orderCardCoremetrics != true)
                    {
                        coremetrics.elementTag('Submit ID Card Order','MEMBER:ACCOUNT SETTINGS');
                        coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:VIEW ID CARD:ORDER SUBMITTED',
                                                          'MEMBER:ACCOUNT SETTINGS');
                        orderCardCoremetrics = true;
                    }
                   Promise.all(orderServiceCalls).then(function (responses) {

                        if(brand.current.sharedBrandCode.toLowerCase() === 'ndbcbs') {
                            modal.open({
                                heading: 'Request Submitted!',
                                template: '<p>Your new cards will arrive in 10 business days. ' +
                                'If your cards do not arrive by then or if you have questions, contact us by phone(1-844-363-8457) or through the ' +
                                '<a title="Customer Service" target="_blank" href="/member/msg/contact-us">secure message center </a>.</p>' +
                                '<p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'
                            });
                        } else if (brand.current.sharedBrandCode.toLowerCase() === 'wybcbs'){
                            modal.open({
                                heading: 'Request Submitted!',
                                template: '<p>New cards will arrive in 10 business days. ' +
                                'If your cards do not arrive by then, send us an email through our website link: ' +
                                '<a title="Customer Service" target="_blank" href="/member/msg/contact-us">Member Services</a>.</p>' +
                                '<p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'});
                        }else{
                            modal.open({
                                    heading: 'Request Submitted!',
                                    template: '<p>New cards will arrive in 10 business days. ' +
                                    'If your cards do not arrive by then, send us an email through our website link: ' +
                                    '<a title="Customer Service" target="_blank" href="/msg/#!/contact-us">Customer Service</a>.</p>' +
                                    '<p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'});
                        }
                        $scope.orderButtonsDisabled = false;
                        $scope.cancelOrder();

                    }, function (responses) {
                        modal.open({
                            heading: 'Error',
                            template: '<p>We are having trouble processing your request right now. ' +
                                       'Try again in a few minutes. If the problem continues, please call the number on the back of your member ID card.</p>' +
                                       '<p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'
                        });
                        $scope.orderButtonsDisabled = false;

                    });
                }
                else {
                    // Verify content here is approved.
                    modal.open({
                        heading: 'Select A Card',
                        template: '<p>Please select at least one card to order.</p>' +
                        '<p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'});
                    $scope.orderButtonsDisabled = false;

                }
            };


            var c = [0,0,0];

            var idCard = storage.get("idCard");
            var cardData = idCard.card.split('-');

            if (cardData) {
                //var cardData = this.self.page.queryParams.c.split('-');
                switch (Number(cardData[0])) {
                    case 0:
                        ums.setFilterState('past');
                        break;
                    case 1:
                        ums.setFilterState('current');
                        // new Article('account/order-id-cards', 'orderIdCardsPlaceholder');
                        break;
                    case 2:
                        ums.setFilterState('future');
                        break;
                }

                c = [Number(cardData[1]), Number(cardData[2]), Number(cardData[3])];


            }
            else {
                // Direct link, probably from old portal.  Detect group, find the client it belongs to, and construct the params
                ums.setFilterState('current');

                var currentPlan = ums.getPortalSelectedPlan();
                currentPlan = currentPlan && currentPlan[0];
                var clients = parsedresponse && parsedresponse.clientList;
                for (var z = 0; z < clients.length; z++) {
                    if ((clients[z].clientId == currentPlan.clientId) && (clients[z].clientNumber == currentPlan.clientNumber)) {
                        c = [Number(z),0,0];
                    }
                }
                // new Article('account/order-id-cards', 'orderIdCardsPlaceholder');
            }

            var groupList	=	ums.fullGroupList();
            var productList	=	ums.fullProductList();

            groupList.forEach(function(group){
                if(group.planPartnerCode==='373' || group.planPartnerCode==='374')
                    $scope.ahPartner='AHNJ';
                else if(group.planPartnerCode==='375')
                    $scope.ahPartner='AHPA';

                if(group.medicareIndicator	===	'true')
                    $scope.medicare =	'true';

                if(group.medigapIndicator==='true')
                    $scope.medigap	=	'true';
            });
            productList.forEach (function(product){
                if(product.isBlueExtraBasic==='true')
                    $scope.blueExtraBasic =	'true';
                if(product.isBlueExtraPlus==='true')
                    $scope.blueExtraPlus =	'true';
                if(product.lob	===	'PPO')
                    $scope.isPPO	=	'true';
                if(product.lob	===	'HMO')
                    $scope.isHMO	=	'true';
            });

            switch (baseInfo.brand.toLowerCase()) {
                case 'ibcah':
                case 'ibccr':
                    $scope.altCardSize = 'altCardSize';
                    break;
                default:
                    $scope.altCardSize = '';
            }

            if (c[0] >= parsedresponse.clientList.length) {
                c = [0,0,0];
            }
            var ind = c[0];

            var members = parsedresponse.clientList[ind].members;


            // Fetch list of members and cards
            $scope.users = members;
            $scope.baseInfo = baseInfo;

            $scope.hasCards = false;
            $scope.hasNonAGCards = false;

            for (var i = 0; i < $scope.users.length; i++) {
                var currentUser = $scope.users[i];
                $scope.users[i].name = currentUser.firstName + ' ' + currentUser.lastName;
                $scope.users[i].value = i;
                $scope.users[i].open = false;
                if (i==0){
                    $scope.selectedMember = {name: $scope.users[i].name,
                    value: $scope.users[i].value};
                }

                for (var z = 0; z < currentUser.cards.length; z++) {
                    var currentCard = $scope.users[i].cards[z],
                        isCardCancelled = false;

                    if (currentCard.iconList[0].can){
                        if(currentCard.iconList[0].can === "NC") {
                            isCardCancelled = true ;
                        } else {
                            var dtCancelDate = new Date(currentCard.iconList[0].can);
                            if (dtCancelDate <  serverDate){
                                isCardCancelled = true ;
                            }
                        }

                    }

                    if (currentCard.iconList && currentCard.iconList[0] && isCardCancelled) {
                        // Card is cancelled, remove it and move on to the next card;
                        $scope.users[i].cards.splice(z, 1);
                        z--;
                        continue;
                        // currentCard.errorMessage = this.errors['cancelled'];
                    }
                    else {
                       // $scope.cardError =true;
                        if (brand.current.sharedBrandCode.toLowerCase() === 'ibccr') {
                            $scope.users[i].cards[z].errorMessage = errors('IBCDOWN');
                        } else if (brand.current.sharedBrandCode.toLowerCase() === 'ibcah') {
                            $scope.users[i].cards[z].errorMessage = errors('IBCAHDOWN');
                        } else {
                            $scope.users[i].cards[z].errorMessage = errors('ecsDown');
                        }
                    }

                    $scope.hasCards = true;

                    var isAg = false;
                    for (var y = 0; y < currentCard.plans.length; y++) {
                        var entry = currentCard.plans[y];
                        if(entry.lob !== 'AG') {
                            $scope.hasNonAGCards = true
                            isAg = false;
                            break;
                        }
                        else {
                            isAg = true;
                        }
                    }
                    if (isAg) {
                        // Card is AG, remove it and move on to the next card;
                        $scope.users[i].cards.splice(z, 1);
                        if(currentUser.cards.length === 0) {
                            $scope.users.splice(i, 1);
                            i--;
                        }
                        z--;
                        continue;
                    }
                    $scope.showError = false;
                    currentCard.checked = false;
                    currentCard.showError = false;
                    currentCard.index = z;
                    currentCard.viewBack = false;
                    currentCard.selected = "selectionOff";
                    currentCard.clientId = currentCard.plans[0].clientId;
                    currentCard.CType = (currentCard.consolidated === "true" ? "CON" : benefitTypeToCType(currentCard.plans[0].benefitPlanType));
                    currentCard.cardType = cardTypeToDisplay(currentCard.plans[0].benefitPlanType);
                    currentCard.GNumber = currentCard.plans[0].groupNumber;
                    currentCard.cardIcon = cardTypeToIcon(currentCard.plans[0].benefitPlanType);
                    currentCard.productNumber = currentCard.plans[0].productNumber;
                    // currentCard.src = "../mbr/app/imgs/getidcard3.jpg";
                    var umiAgreementIdSuffix;
                    for (var ii = 0; ii < currentUser.groups.length; ii++) {
                        if (currentUser.groups[ii].clientId == currentCard.clientId && currentUser.groups[ii].groupNumber == currentCard.groupNumber) {
                            umiAgreementIdSuffix = currentUser.groups[ii].umiAgreementIdSuffix;
                        }
                    }
                    $scope.users[i].cards[z].src = "/rbsmbl/x-services/idcard/getidcard?MProfileId="+
                        "&UId="+memberData.userName+
                        "&GNumber="+currentCard.plans[0].groupNumber+
                        "&UNumber="+baseInfo.umi+(umiAgreementIdSuffix ? umiAgreementIdSuffix : '')+
                        "&EciId="+(currentUser.ecId || '')+
                        "&CType="+(currentCard.consolidated === "true" ? "CON" : benefitTypeToCType(currentCard.plans[0].benefitPlanType))+
                        "&SID=WEB"+
                        "&logoId="+baseInfo.brand+
                        "&covIndId="+currentUser.ciid+
                        "&MTMID=viewIdCard"+
                        "&timestamp="+Number(new Date());

                    if (ums.getFilterState().toLowerCase() === 'future' && (brand.current.sharedBrandCode.toLowerCase() === 'ibccr' || brand.current.sharedBrandCode.toLowerCase() === 'ibcah')) {
                        $scope.users[i].cards[z].src = $scope.users[i].cards[z].src + "&EDate="+ date.formatDate(currentUser.coverageEffectiveDate, "yyyy-MM-dd");
                    }

                    $http.get( $scope.users[i].cards[z].src).then(function(success){
                        $scope.success = success;

                        if($scope.success.data && $scope.success.data.baseMessage && $scope.success.data.baseMessage.returnCode == 200){ currentCard.showError =false;}
                        else{
                            currentCard.showError =true;
                            $scope.showError = true ;
                            window.scrollTo(0,0);
                        }



                    }, function(failure){

                        currentCard.showError =true;
                        $scope.showError = true ;
                        window.scrollTo(0,0);




                    }.bind(currentCard));

                    $scope.users[i].cards[z] = currentCard;

                }

                // If user has no cards, remove them
                if (currentUser.cards.length === 0) {
                    $scope.users.splice(i, 1);
                    i--;
                }
            }

            // If there are no users, show the default error msg
            if ($scope.users.length === 0) {
                $scope.fullPageError = true;
                if ($scope.hasCards) {
                    if (!$scope.hasNonAGCards) {
                        // User has cards, but only AG cards, show the form
                        $scope.orderingBlocked = true;
                    }
                }
                else {
                    // User has no cards
                    $scope.orderingBlocked = true;
                }
                return;
            }

            //order id card
            if ($scope.hasCards) {
                if (!$scope.hasNonAGCards) {
                    // User has cards, but only AG cards, show the form
                    $scope.orderForm = true;
                }
            }

            // Uncomment the below code to duplicate id cards, used for testing card swippign when users normally only have 1 card
            // model.users[0].cards.push(lang.clone(model.users[0].cards[0]));
            // model.users[0].cards[1].index = 1;
            // model.users[0].cards[1].placement = 1;

            if (c[1] >= $scope.users.length) {
                c = [c[0],0,0];
            }
            $scope.selectedMember.value = c[1];

            for (var jj = 0; jj < $scope.users.length; jj++) {
                var user = $scope.users[jj];
                for (var ii = 0; ii < user.cards.length; ii++) {
                    var card = user.cards[ii];
                    if (card.id.split('-').slice(1).join('-') == c.join('-')) {
                        // found the card, capture these indexes
                        c = [c[0],jj,ii];
                        break;
                    }
                }
            }

            if ($scope.users[c[1]] && $scope.users[c[1]].cards && c[2] >= $scope.users[c[1]].cards.length) {
                c = [c[0],c[1],0];
            }
            $scope.selectedMemberChange();
            //$scope.idCardScroll.pos = c[2];


            //id-card slide
            var slideIndex =0 ;
            //function for prev/next button
            $scope.nextDivs= function(n) {

                showDivs(slideIndex += n);
            };

            //function call for id card icon
            $scope.currentDiv = function(n) {

                showDivs( slideIndex = n);
            };
            //function for the idcard slide feature
            var showDivs = function(n) {
                var i;
                var imgList = document.getElementsByClassName("idCardImgDiv");
                var iconSelected = document.getElementsByClassName("iconButton");
                var obj_len = iconSelected.length;

                if (n >= imgList.length) {slideIndex = 0;}
                if (n < 0) {slideIndex = imgList.length;}

                var display= slideIndex;

                if (display >= imgList.length && display >1){
                    display = imgList.length -1;
                    slideIndex = imgList.length-1;
                }
                for (i = 0; i < imgList.length; i++) {
                    imgList[i].style.display = "none";

                }
                for (i = 0; i < iconSelected.length; i++) {
                    iconSelected[i].className = iconSelected[i].className.replace("selected", "selectionOff");
                }
                console.log("id card display image of",display);
                console.log("slideIndex",slideIndex);
                console.log("icon selected",iconSelected[display]);

                imgList[display].style.display = "block";
                iconSelected[display].className = iconSelected[display].className.replace("selectionOff","selected");
            };








            //set email to model for fax id card   AND   address for order id card
            services.rbsmbl.AccountSettingsRetrive()
                .retriveAccountSettings(sessionData.groupNumber,"getEmail",memberData.brand,memberData.userName)
                .then(function(respData){
                $scope.accountData = respData.data;
                $scope.email = $scope.accountData.payload.emailAddress;
                                      // ORDER ID CARD
                $scope.address = {
                    address1: {value:$scope.accountData.payload.address1},
                    address2: {value:$scope.accountData.payload.address2} ,
                    address3: {value:$scope.accountData.payload.address3} ,
                    address4: {value:$scope.accountData.payload.address4} ,
                    city: {value:$scope.accountData.payload.city} ,
                    state: {value:$scope.accountData.payload.state},
                    zip:{value:$scope.accountData.payload.zip}
                };
                 $scope.backupAddress = angular.copy($scope.address);
                 $scope.stateList = $scope.accountData.payload.stateDropdown;
                 $scope.memberLoggedIn = ums.currentMember();
                 $scope.mtmData = angular.extend({}, $scope.accountData.payload,  {"mtmMemberList":mtmMembers || []});

                 var mtmMembers =  angular.copy($scope.users);

                 //remove all non medical cards from mtm payload
                  for (var a = 0; a < $scope.mtmData.mtmMemberList.length; a++) {
                      var mtmMember = mtmMembers[a];
                      for (var b = 0; b < mtmMember.cards.length; b++) {
                          var mtmCurrentCard = mtmMember.cards[b];
                          if (mtmCurrentCard.cardType !== "Medical"){
                              mtmMember.cards.splice(b, 1);
                          }else if (mtmCurrentCard.cardType === "Medical"){
                              allowSend = true;
                          }
                      }
                  }
                   if (allowSend){
                    //call mtm save service to persist member info - mandate
                     services.rbsmbl.capabilityInfo().persistMTMInfo($scope.mtmData, 'orderIdCardView');
                   }

            });

            // Visibility for Email ID Card Functionality and suppress for ND (RF629767)
            $scope.emailIdCardView =false;
            switch (baseInfo.brand.toLowerCase()) {
                case 'mincr':
                    $scope.emailIdCardView = true;
                    $scope.buttonLayoutClass = 'four-column';
                    break;
                // case 'ndbcbs':
                //     model.emailIdCardView = true;
                //     model.buttonLayoutClass = 'four-column';
                //     break;
                case 'wybcbs':
                    $scope.emailIdCardView = true;
                    $scope.buttonLayoutClass = 'four-column';
                    break;
                default:
                    $scope.emailIdCardView = false;
            }


            $timeout(function(){
                showDivs(0);
            },100);

        }
    ]);
    app.directive("limitTo", [function() {
        return {
            restrict: "A",
            link: function(scope, elem, attrs) {
                var limit = parseInt(attrs.limitTo);
                angular.element(elem).on("keypress", function(e) {
                    if (this.value.length == limit) e.preventDefault();
                });
            }
        };
    }]);


};